import { STATUS_STYLES } from "../data/site";

export function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-${status.toLowerCase().replace(/\s/g, "-")}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-mono-ez uppercase tracking-wider font-semibold ${
        STATUS_STYLES[status] || "bg-ez-text/10 text-ez-text"
      }`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {status}
    </span>
  );
}

export function Placeholder({ label = "Placeholder" }) {
  return (
    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 text-[10px] font-mono-ez uppercase tracking-wider border border-dashed border-ez-text/40 text-ez-text/50">
      {label}
    </span>
  );
}
